// Three Tides - Theme JS

// Add to cart via Shopify AJAX API
function ttAddToCart(event, variantId) {
  event.preventDefault();
  event.stopPropagation();
  var btn = event.target;
  var originalText = btn.textContent;
  btn.textContent = 'Adding...';
  btn.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
  })
  .then(function(res) { return res.json(); })
  .then(function() {
    btn.textContent = 'Added!';
    btn.style.background = '#2d8fa5';
    // Update cart count in nav
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        document.querySelectorAll('.tt-cart-bubble').forEach(function(el) {
          el.textContent = cart.item_count;
        });
      });
    setTimeout(function() {
      btn.textContent = originalText;
      btn.disabled = false;
      btn.style.background = '';
    }, 2000);
  })
  .catch(function() {
    btn.textContent = 'Error - Try Again';
    setTimeout(function() {
      btn.textContent = originalText;
      btn.disabled = false;
    }, 2000);
  });
}

// Mobile nav toggle
document.addEventListener('DOMContentLoaded', function() {
  var toggle = document.querySelector('.tt-nav-toggle');
  var mobileNav = document.querySelector('.tt-mobile-nav');

  if (toggle && mobileNav) {
    toggle.addEventListener('click', function() {
      mobileNav.classList.toggle('tt-open');
    });
    // Close mobile nav when clicking a link
    mobileNav.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() {
        mobileNav.classList.remove('tt-open');
      });
    });
  }
});
